import greyButtonVariant from './greyButtonVariant';

// Given a base theme, creates the config for further MUI 5 theme options
export const getThemeConfig = theme => ({
  palette: {
    grey: {
      main: theme.palette.grey[300],
      dark: theme.palette.grey[400],
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        color: 'grey',
      },
      variants: [...greyButtonVariant(theme)],
    },
    MuiTab: {
      defaultProps: {
        sx: {
          minWidth: 160,
        },
      },
    },
  },
});
